import { gql } from '@apollo/client';

export const SEARCH_AVAILABLE_ROUTES = gql`
  query SearchAvailableRoutes($searchInput: SearchInput) {
    searchAvailableRoutes(searchInput: $searchInput) {
      items {
        id
        cableTag
        racewayTag
        serviceLevelRacewayId
        serviceLevelRacewayName
        isBarriered
        isRecalcRequired
        racewayType
        racewayCodeId
        racewayCodeTag
        primaryStatus
        engineeringStatus
        secondaryStatus
        constructionStatus
        parentSecondaryStatus
        addlServiceLevelRacewayId
        addlServiceLevelRacewayName
        separationGroupRacewayId
        separationGroupRacewayName
        engrLength
        totalNoOfCables
        totalPctFill
        totalAvailPctFill
        totalAvailSpace
        totalWeightPerUnit
        totalOverfillFlag
        totalOverweightFlag
        via {
          racewayId
          sequenceNumber
        }
      }
    }
  }
`;

export const GET_VIA_RACEWAY_BY_RACEWAY_AND_SL_ID = gql`
  query getViaRacewayByRacewayAndSLId($viaRequests: [ViaRequest!]!) {
    getViaRacewayByRacewayAndSLId(viaRequests: $viaRequests) {
      racewayId
      racewayTag
      serviceLevelRacewayId
      serviceLevelRacewayName
      isBarriered
      isRecalcRequired
      racewayType
      racewayCodeTag
      primaryStatus
      engineeringStatus
      secondaryStatus
      constructionStatus
      parentSecondaryStatus
      addlServiceLevelRacewayId
      addlServiceLevelRacewayName
      separationGroupRacewayId
      separationGroupRacewayName
      engrLength
      totalNoOfCables
      totalPctFill
      totalAvailPctFill
      totalAvailSpace
      totalWeightPerUnit
      totalOverfillFlag
      totalOverweightFlag
    }
  }
`;
